import { useState as h, useMemo as s } from "react";
import { estimateTextWidth as a } from "@placer-ui/hooks";
const p = 150, n = 24, c = (t) => {
  const [r, f] = h(!1);
  return { maxWidth: s(() => {
    let i = p;
    return t == null || t.forEach((o) => {
      if (typeof o.label == "string") {
        let e = a(o.label);
        o.LeftComponent && (e += n), o.RightComponent && (e += n), e > i && (i = e);
      }
    }), i;
  }, [t]), isMenuOpen: r, setIsMenuOpen: f };
};
export {
  c as useMenuWidth
};
//# sourceMappingURL=index.es5661.js.map
